import axios from 'axios';
import { from } from 'rxjs';
import get from 'lodash.get';

import { LogService } from '../../services/log-service';

export const getSharedServices = (fulfillmentPlanId) => {
  const request = axios.get(`/carriersharing/partner/${fulfillmentPlanId}/services`).then((response) => {
    return get(response, 'data', undefined);
  });

  return from(request);
};

export const getPartnerSharedServices = async () => {
  try {
    const response = await axios.get('/carriersharing/partner/services');
    return response?.data ?? [];
  } catch (error) {
    LogService.logInfo(error, 'Error fetching partner shared services');
    return [];
  }
};

export const getPartnerSharedCarrierIds = async () => {
  try {
    const response = await axios.get('/carriersharing/partner/carrierids');
    return response?.data ?? [];
  } catch (error) {
    LogService.logInfo(error, 'Error fetching partner shared carriers');
    return [];
  }
};

export const getPartnerSharedSellerLabelProviders = async () => {
  try {
    const response = await axios.get('/carriersharing/partner/provider/seller');
    return response?.data ?? [];
  } catch (error) {
    LogService.logInfo(error, 'Error fetching partner shared label providers');
    return [];
  }
};

export const getPartnerSharedLabelProviders = async () => {
  try {
    const response = await axios.get('/carriersharing/partner/labelproviders');
    return response?.data ?? [];
  } catch (error) {
    LogService.logInfo(error, 'Error fetching partner shared label providers');
    return [];
  }
};

export const getPartnerSharedSellersServices = async () => {
  try {
    const response = await axios.get('/carriersharing/partner/seller/services');
    return response?.data ?? [];
  } catch (error) {
    LogService.logInfo(error, 'Error fetching partner shared sellers services');
    return [];
  }
};

export const getPartnerSharedPackageTypes = async () => {
  try {
    const response = await axios.get('/carriersharing/partner/packagetypes');
    return response?.data ?? [];
  } catch (error) {
    LogService.logInfo(error, 'Error fetching partner shared package types');
    return [];
  }
};
